import { BulkAddArgs, SyncManager } from 'db';
import { useField } from 'react-final-form';
import { useFormVehicleId } from './useFormVehicleId';
import { base64ToObjectUrl, dataURItoBlob } from 'utils';
import { useFieldArray } from 'react-final-form-arrays';

export type SaveImageFn = (payload: {
  file?: File | string | null;
  is_damaged?: boolean;
  grade?: number;
  notes?: number;
}) => Promise<void>;

export const useBulkAddImages = (sectionId: string) => {
  const { fields } = useFieldArray(`${sectionId}.images`);
  const vehicleId = useFormVehicleId();

  const save = async (payload: BulkAddArgs) => {
    if (!vehicleId || payload.length === 0) return;
    const syncManager = SyncManager.getInstance(vehicleId);

    await syncManager.queueBulkNewImages(payload);

    for (const newImage of payload) {
      const blob = new Blob([newImage.file], { type: 'image/jpeg' });
      fields.push({
        id: newImage.entityId,
        local_url: URL.createObjectURL(blob)
      });
    }
  };

  return save;
};
